import React from 'react';
import { PromiseCardProps } from '../types';

const PromiseCard: React.FC<PromiseCardProps> = ({ card }) => {
  return (
    <div className="w-1/3 sm:w-full px-3 sm:pb-7 sm:pl-0">
      <div className="">
        <div className="">
          <img
            className="h-12"
            src={card.src}
            alt={card.alt}
            width="48"
            height="48"
            loading="lazy"
          />
        </div>
        <div className="sm:pt-6">
          <h5
            className="sm:text-s-24 mt-6 sm:mt-0"
            dangerouslySetInnerHTML={{ __html: card.title }}
          />
          <p
            className="mt-5 sm:mt-4"
            dangerouslySetInnerHTML={{ __html: card.description }}
          />
        </div>
      </div>
    </div>
  );
};

export default PromiseCard;
